<app-side-menu>
  <div class="accounts-payable-form-content">
    <!-- Escolha do tipo (acesso direto à rota /new sem ?mode=) -->
    <div class="row" *ngIf="showModePicker && !isEditMode">
      <div class="col-12">
        <div class="page-header mb-4">
          <h1 class="page-title"><i class="fas fa-file-invoice-dollar me-3"></i>Nova Conta a Pagar</h1>
          <p class="page-subtitle">Selecione o tipo de cadastro para continuar</p>
        </div>
        <div class="row g-3 ap-create-mode-cards mb-4">
          <div class="col-md-4" *ngFor="let mode of createModeOptions">
            <button type="button" class="ap-create-mode-card" (click)="selectCreateMode(mode)">
              <i class="fas fa-2x text-primary mb-2"
                 [ngClass]="{
                   'fa-receipt': mode === 'normal',
                   'fa-calendar-alt': mode === 'parcelado',
                   'fa-chart-pie': mode === 'rateio'
                 }"></i>
              <strong>{{ createModeLabels[mode] }}</strong>
            </button>
          </div>
        </div>
        <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
          <i class="fas fa-arrow-left me-2"></i>Voltar à listagem
        </button>
      </div>
    </div>

    <!-- Header -->
    <div class="row mb-4" *ngIf="!showModePicker">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center">
            <button 
              type="button"
              class="btn btn-outline-secondary me-3"
              (click)="cancel()">
              <i class="fas fa-arrow-left me-2"></i>
              Voltar
            </button>
            <div>
              <h1 class="page-title">
                <i class="fas fa-file-invoice-dollar me-3"></i>
                {{ isEditMode ? 'Editar Conta a Pagar' : 'Nova Conta a Pagar' }}
              </h1>
              <p class="page-subtitle">
                <span *ngIf="isEditMode">Atualize as informações da conta a pagar</span>
                <span *ngIf="!isEditMode && createModeLabel">
                  <span class="badge bg-light text-dark me-2">{{ createModeLabel }}</span>
                  Cadastro em etapas do financeiro
                </span>
                <span *ngIf="!isEditMode && !createModeLabel">Cadastre uma nova conta a pagar</span>
              </p>
            </div>
            <button
              *ngIf="!isEditMode && createMode"
              type="button"
              class="btn btn-sm btn-outline-light ms-auto"
              (click)="backToCreateModePicker()">
              Trocar tipo
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Formulário -->
    <div class="row" *ngIf="!showModePicker">
      <div class="col-12">
        <div class="accounts-payable-form-card">
          <app-form-shell
            [tabs]="availableTabs"
            [activeTab]="activeTab"
            (tabChange)="selectTab($event)">
          </app-form-shell>

          <!-- Step 1: Informações do Documento -->
          <div *ngIf="currentStep === 1" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-file-alt me-2"></i>
              Informações do Documento
            </h3>
            <div class="alert alert-light border py-2 small mb-3" *ngIf="!isEditMode && isRateioMode">
              <i class="fas fa-arrow-right me-1 text-primary"></i>
              Na próxima aba informe <strong>quantas parcelas (meses)</strong>, <strong>quantos centros de custo</strong> e o <strong>% de cada um</strong>.
            </div>
            <div class="alert alert-light border py-2 small mb-3" *ngIf="!isEditMode && isParceladoMode">
              <i class="fas fa-arrow-right me-1 text-primary"></i>
              Na próxima aba defina <strong>parcelas</strong>, <strong>centro de custo</strong> e o <strong>valor de cada parcela</strong>.
            </div>
            <div class="alert alert-light border py-2 small mb-3" *ngIf="!isEditMode && isNormalCreateMode">
              <i class="fas fa-arrow-right me-1 text-primary"></i>
              Cadastro de <strong>pagamento único</strong> — valores e vencimento na próxima aba.
            </div>
            
            <div [formGroup]="formStep1" class="row g-3">
              <div class="col-md-4">
                <label for="documentNumber" class="form-label">Número do Documento *</label>
                <input 
                  type="text" 
                  id="documentNumber"
                  class="form-control"
                  formControlName="documentNumber"
                  [class.is-invalid]="isFieldInvalid('documentNumber', 1)"
                  [class.is-valid]="documentNumber?.valid"
                  placeholder="Ex: NF001234">
                
                <div class="invalid-feedback" *ngIf="isFieldInvalid('documentNumber', 1)">
                  {{ getFieldError('documentNumber', 1) }}
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="documentType" class="form-label">Tipo do Documento *</label>
                <select 
                  id="documentType"
                  class="form-select"
                  formControlName="documentType"
                  [class.is-invalid]="isFieldInvalid('documentType', 1)">
                  <option value="">Selecione...</option>
                  <option *ngFor="let type of documentTypes" [value]="type">
                    {{ type }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('documentType', 1)">
                  {{ getFieldError('documentType', 1) }}
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="issueDate" class="form-label">Data de Emissão *</label>
                <input 
                  type="date" 
                  id="issueDate"
                  class="form-control"
                  formControlName="issueDate"
                  [class.is-invalid]="isFieldInvalid('issueDate', 1)">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('issueDate', 1)">
                  {{ getFieldError('issueDate', 1) }}
                </div>
              </div>
              
              <div class="col-md-6">
                <label for="invoiceNumber" class="form-label">Número da Nota Fiscal</label>
                <input 
                  type="text" 
                  id="invoiceNumber"
                  class="form-control"
                  formControlName="invoiceNumber"
                  placeholder="Ex: 123456">
              </div>
              
              <div class="col-md-6">
                <label for="purchaseOrderNumber" class="form-label">Número do Pedido de Compra</label>
                <input 
                  type="text" 
                  id="purchaseOrderNumber"
                  class="form-control"
                  formControlName="purchaseOrderNumber"
                  placeholder="Ex: PC001234">
              </div>
              
              <div class="col-12">
                <label for="description" class="form-label">Descrição</label>
                <textarea 
                  id="description"
                  class="form-control"
                  formControlName="description"
                  rows="3"
                  [placeholder]="isRateioMode ? 'Ex.: Aluguel escritório — no lote, cada título incluirá o % e o valor total do mês' : 'Descrição da conta a pagar...'"></textarea>
                <small class="text-muted" *ngIf="isRateioMode">
                  No modo <strong>divisão em centro de custo</strong>, cada título gerado traz na descrição o
                  <strong>percentual</strong> e o <strong>valor total do mês</strong> (ex.: 50% de R$ 160,00).
                </small>
              </div>
            </div>
          </div>

          <!-- Step 2: Valores e Vencimento -->
          <div *ngIf="currentStep === 2" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-calculator me-2"></i>
              Valores e Vencimento
            </h3>
            <p class="text-muted small mb-3" *ngIf="isRateioMode">
              Informe o valor <strong>mensal</strong>, quantas parcelas gerar e em quantos centros de custo dividir.
            </p>
            <p class="text-muted small mb-3" *ngIf="isParceladoMode">
              O valor informado é o de <strong>cada parcela</strong> (desconto, juros e multa valem em todas).
              O total do lote = valor da parcela × quantidade de parcelas.
            </p>
            
            <div [formGroup]="formStep2" class="row g-3">

              <!-- Parcelado: várias parcelas, um CC -->
              <div class="col-12" *ngIf="isParceladoMode">
                <div class="ap-lote-section">
                  <h6 class="ap-lote-section-title">
                    <i class="fas fa-calendar-alt me-2"></i>
                    Parcelamento da conta
                  </h6>
                  <div class="row g-3">
                    <div class="col-md-4">
                      <label for="totalInstallments" class="form-label">Quantidade de parcelas *</label>
                      <input
                        type="number"
                        id="totalInstallments"
                        class="form-control"
                        formControlName="totalInstallments"
                        min="2"
                        max="120"
                        placeholder="Ex: 6" />
                    </div>
                    <div class="col-md-4">
                      <label for="billingIntervalPreset" class="form-label">Intervalo entre vencimentos</label>
                      <select id="billingIntervalPreset" class="form-select" formControlName="billingIntervalPreset">
                        <option *ngFor="let opt of billingIntervalPresets" [value]="opt.value">{{ opt.label }}</option>
                      </select>
                    </div>
                    <div class="col-md-4" *ngIf="isBillingIntervalCustom()">
                      <label for="billingIntervalCustomDays" class="form-label">Dias personalizados</label>
                      <div class="input-group">
                        <input
                          type="number"
                          id="billingIntervalCustomDays"
                          class="form-control"
                          formControlName="billingIntervalCustomDays"
                          min="1"
                          max="365" />
                        <span class="input-group-text">dias</span>
                      </div>
                    </div>
                    <div class="col-md-4" [formGroup]="formStep3">
                      <label for="costCenterIdParcelado" class="form-label">Centro de custo *</label>
                      <select
                        id="costCenterIdParcelado"
                        class="form-select"
                        formControlName="costCenterId"
                        [class.is-invalid]="isFieldInvalid('costCenterId', 3)"
                        (change)="onParceladoCostCenterChange()">
                        <option value="">Selecione...</option>
                        <option *ngFor="let costCenter of costCenters" [value]="costCenter.id">
                          {{ costCenter.name }}
                        </option>
                      </select>
                      <div class="invalid-feedback" *ngIf="isFieldInvalid('costCenterId', 3)">
                        {{ getFieldError('costCenterId', 3) }}
                      </div>
                      <small class="text-muted">Mesmo centro de custo em todas as parcelas.</small>
                    </div>
                  </div>
                  <div
                    class="ap-parcelado-lote-hint small mt-2"
                    *ngIf="batchInstallmentNetAmount > 0 && parceladoInstallmentCount >= 2">
                    <i class="fas fa-layer-group me-1 text-primary"></i>
                    <strong>{{ batchInstallmentNetAmount | currency:'BRL':'symbol':'1.2-2' }}</strong>
                    por parcela × <strong>{{ parceladoInstallmentCount }}</strong> =
                    <strong>{{ batchExpectedLoteTotal | currency:'BRL':'symbol':'1.2-2' }}</strong> no lote
                    <span *ngIf="batchPreviewRows.length > 0">(espelhado na prévia abaixo).</span>
                  </div>
                </div>
              </div>

              <!-- Divisão em centro de custo: parcelas + N centros -->
              <div class="col-12" *ngIf="isRateioMode">
                <div class="ap-lote-section">
                  <h6 class="ap-lote-section-title">
                    <i class="fas fa-chart-pie me-2"></i>
                    Divisão em centro de custo
                  </h6>
                  <div class="row g-3">
                    <div class="col-md-4">
                      <label for="totalInstallmentsRateio" class="form-label">Quantidade de parcelas (meses) *</label>
                      <input
                        type="number"
                        id="totalInstallmentsRateio"
                        class="form-control"
                        formControlName="totalInstallments"
                        min="1"
                        max="120"
                        placeholder="Ex: 6" />
                    </div>
                    <div class="col-md-4">
                      <label for="costCenterCount" class="form-label">Quantos centros de custo? *</label>
                      <input
                        type="number"
                        id="costCenterCount"
                        class="form-control"
                        [ngModel]="costCenterCount"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="onCostCenterCountChange($event)"
                        min="1"
                        max="20"
                        placeholder="Ex: 3" />
                      <small class="text-muted">Abre uma linha para definir o % de cada centro.</small>
                    </div>
                    <div class="col-md-4">
                      <label for="billingIntervalPresetRateio" class="form-label">Intervalo entre vencimentos</label>
                      <select id="billingIntervalPresetRateio" class="form-select" formControlName="billingIntervalPreset">
                        <option *ngFor="let opt of billingIntervalPresets" [value]="opt.value">{{ opt.label }}</option>
                      </select>
                    </div>
                    <div class="col-md-4" *ngIf="isBillingIntervalCustom()">
                      <label for="billingIntervalCustomDaysRateio" class="form-label">Dias personalizados</label>
                      <div class="input-group">
                        <input
                          type="number"
                          id="billingIntervalCustomDaysRateio"
                          class="form-control"
                          formControlName="billingIntervalCustomDays"
                          min="1"
                          max="365" />
                        <span class="input-group-text">dias</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <label for="originalAmount" class="form-label">
                  {{ isRateioMode ? 'Valor total do mês *' : (isParceladoMode ? 'Valor de cada parcela *' : 'Valor Total *') }}
                </label>
                <div class="input-group">
                  <span class="input-group-text">R$</span>
                  <input 
                    type="text" 
                    id="originalAmount"
                    class="form-control"
                    formControlName="originalAmount"
                    appCurrencyShiftMask
                    [class.is-invalid]="isFieldInvalid('originalAmount', 2)"
                    inputmode="decimal"
                    autocomplete="off"
                    placeholder="0,00">
                </div>
                <small class="text-muted" *ngIf="isRateioMode">
                  Ex.: R$ 160,00 com 50% + 50% → R$ 80,00 em cada centro de custo (por mês).
                </small>
                <small class="text-muted" *ngIf="isParceladoMode">
                  Valor líquido repetido em cada parcela (com desconto/juros/multa, se informados).
                </small>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('originalAmount', 2)">
                  {{ getFieldError('originalAmount', 2) }}
                </div>
              </div>
              
              <div class="col-md-6">
                <label for="dueDate" class="form-label">
                  {{ isBatchMode ? 'Data do 1º vencimento *' : 'Data de Vencimento *' }}
                </label>
                <input 
                  type="date" 
                  id="dueDate"
                  class="form-control"
                  formControlName="dueDate"
                  [class.is-invalid]="isFieldInvalid('dueDate', 2)">
                <small class="text-muted" *ngIf="isBatchMode">Demais vencimentos seguem o intervalo configurado.</small>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('dueDate', 2)">
                  {{ getFieldError('dueDate', 2) }}
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="discountAmount" class="form-label">Desconto</label>
                <div class="input-group">
                  <span class="input-group-text">R$</span>
                  <input 
                    type="text" 
                    id="discountAmount"
                    class="form-control"
                    formControlName="discountAmount"
                    appCurrencyShiftMask
                    inputmode="decimal"
                    autocomplete="off"
                    placeholder="0,00">
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="interestAmount" class="form-label">Juros</label>
                <div class="input-group">
                  <span class="input-group-text">R$</span>
                  <input 
                    type="text" 
                    id="interestAmount"
                    class="form-control"
                    formControlName="interestAmount"
                    appCurrencyShiftMask
                    inputmode="decimal"
                    autocomplete="off"
                    placeholder="0,00">
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="fineAmount" class="form-label">Multa</label>
                <div class="input-group">
                  <span class="input-group-text">R$</span>
                  <input 
                    type="text" 
                    id="fineAmount"
                    class="form-control"
                    formControlName="fineAmount"
                    appCurrencyShiftMask
                    inputmode="decimal"
                    autocomplete="off"
                    placeholder="0,00">
                </div>
              </div>

              <!-- Esboço parcelado: parcelas, datas e valores -->
              <div class="col-12" *ngIf="showParceladoEsboco">
                <div class="ap-lote-section ap-parcelado-esboco">
                  <h6 class="ap-lote-section-title mb-2">
                    <i class="fas fa-list-alt me-2"></i>
                    Como ficará o parcelamento
                    <span class="badge bg-primary ms-2">{{ parceladoEsbocoRows.length }} parcela(s)</span>
                  </h6>
                  <div class="form-check mb-2" *ngIf="showBatchDueDateOptions">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="adjustWeekendsBusinessDayParcelado"
                      [(ngModel)]="adjustWeekendsToBusinessDay"
                      [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="onAdjustWeekendsToBusinessDayChange($event)" />
                    <label class="form-check-label" for="adjustWeekendsBusinessDayParcelado">
                      Ajustar <strong>sábado e domingo</strong> para o <strong>próximo dia útil</strong> (segunda-feira)
                    </label>
                  </div>
                  <p class="text-muted small mb-2">
                    <i class="fas fa-info-circle me-1"></i>
                    Esboço em <strong>dias corridos</strong> a partir do 1º vencimento.
                    Use o <i class="fas fa-pencil-alt"></i> para alterar uma data manualmente.
                    <span *ngIf="!isParceladoEsbocoUsingFullPreview"> Informe o valor de cada parcela para ver os valores finais.</span>
                    Clique no cabeçalho da tabela para ordenar (documento, vencimento, valor, etc.).
                  </p>
                  <p class="text-danger small mb-2" *ngIf="hasWeekendDueDatesInPreview">
                    <i class="fas fa-exclamation-triangle me-1"></i>
                    Vencimento em <strong>fim de semana</strong> aparece em vermelho — ajuste com o lápis se necessário.
                  </p>
                  <div class="preview-table-wrap">
                    <table class="table table-sm table-striped mb-0">
                      <thead>
                        <tr>
                          <th class="ap-sortable-th" (click)="toggleBatchPreviewSort('line')" title="Ordenar por sequência">
                            # <i class="fas fa-xs ms-1" [ngClass]="getBatchSortIconClass('line')"></i>
                          </th>
                          <th class="ap-sortable-th" (click)="toggleBatchPreviewSort('document')" title="Ordenar por documento">
                            Documento <i class="fas fa-xs ms-1" [ngClass]="getBatchSortIconClass('document')"></i>
                          </th>
                          <th class="ap-sortable-th" (click)="toggleBatchPreviewSort('installment')" title="Ordenar por parcela">
                            Parcela <i class="fas fa-xs ms-1" [ngClass]="getBatchSortIconClass('installment')"></i>
                          </th>
                          <th class="ap-sortable-th" (click)="toggleBatchPreviewSort('dueDate')" title="Ordenar por vencimento">
                            Vencimento <i class="fas fa-xs ms-1" [ngClass]="getBatchSortIconClass('dueDate')"></i>
                          </th>
                          <th class="ap-sortable-th" (click)="toggleBatchPreviewSort('costCenter')" title="Ordenar por centro de custo">
                            Centro de custo <i class="fas fa-xs ms-1" [ngClass]="getBatchSortIconClass('costCenter')"></i>
                          </th>
                          <th class="ap-sortable-th text-end" (click)="toggleBatchPreviewSort('amount')" title="Ordenar por valor (maior no topo ao descer)">
                            Valor <i class="fas fa-xs ms-1" [ngClass]="getBatchSortIconClass('amount')"></i>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let row of sortedParceladoEsbocoRows">
                          <td>{{ row.lineNumber }}</td>
                          <td class="ap-doc-cell" [title]="row.documentNumber">{{ row.documentNumber }}</td>
                          <td>{{ row.monthIndex }}/{{ row.monthTotal }}</td>
                          <td class="ap-preview-due-date">
                            <ng-container *ngIf="editingDueDateDocumentNumber !== row.documentNumber">
                              <span
                                [class.ap-due-date-weekend]="showWeekendDueDateWarning(row.dueDate)"
                                [class.text-primary]="isBatchDueDateOverridden(row.documentNumber) && !showWeekendDueDateWarning(row.dueDate)">
                                {{ row.dueDate | date:'dd/MM/yyyy' }}
                              </span>
                              <span
                                class="badge bg-light text-muted border ms-1"
                                *ngIf="isBatchDueDateOverridden(row.documentNumber)">ajustado</span>
                              <button
                                type="button"
                                class="btn btn-link btn-sm ap-due-date-edit-btn p-0 ms-1"
                                (click)="startEditBatchDueDate(row)"
                                title="Alterar vencimento">
                                <i class="fas fa-pencil-alt"></i>
                              </button>
                              <button
                                type="button"
                                class="btn btn-link btn-sm text-muted p-0 ms-1"
                                *ngIf="isBatchDueDateOverridden(row.documentNumber)"
                                (click)="resetBatchDueDateOverride(row)"
                                title="Voltar ao automático">
                                <i class="fas fa-undo"></i>
                              </button>
                            </ng-container>
                            <div
                              class="d-flex align-items-center gap-1"
                              *ngIf="editingDueDateDocumentNumber === row.documentNumber">
                              <input
                                type="date"
                                class="form-control form-control-sm"
                                [ngModel]="formatDueDateForInput(row.dueDate)"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="onBatchPreviewDueDateChange(row, $event)" />
                              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="cancelEditBatchDueDate()">
                                <i class="fas fa-times"></i>
                              </button>
                            </div>
                          </td>
                          <td>
                            <span *ngIf="row.costCenterId">{{ getCostCenterName(row.costCenterId) }}</span>
                            <span class="text-muted" *ngIf="!row.costCenterId">Selecione o CC acima</span>
                          </td>
                          <td class="text-end">
                            <span *ngIf="row.amount > 0" class="fw-semibold">{{ row.amount | currency:'BRL' }}</span>
                            <span *ngIf="row.amount <= 0" class="text-muted">—</span>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot *ngIf="batchInstallmentNetAmount > 0 && isParceladoEsbocoUsingFullPreview">
                        <tr class="table-light">
                          <th colspan="5" class="text-end">Total do lote</th>
                          <th class="text-end text-primary">{{ batchPreviewAmountTotal | currency:'BRL':'symbol':'1.2-2' }}</th>
                        </tr>
                        <tr class="table-light">
                          <td colspan="6" class="small border-0 pt-0">
                            {{ parceladoInstallmentCount }} × {{ batchInstallmentNetAmount | currency:'BRL':'symbol':'1.2-2' }} =
                            <strong>{{ batchExpectedLoteTotal | currency:'BRL':'symbol':'1.2-2' }}</strong>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
              <p class="text-muted small mb-0" *ngIf="isParceladoMode && !showParceladoEsboco">
                Defina <strong>2 ou mais parcelas</strong> e a <strong>data do 1º vencimento</strong> para ver o esboço.
              </p>
              
              <div class="col-12" *ngIf="isRateioMode">
                <div class="ap-batch-panel" [class.ap-rateio-invalid]="allocationPercentExcess > 0">
                  <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
                    <strong><i class="fas fa-percent me-2"></i>Percentual por centro de custo ({{ costCenterCount }})</strong>
                    <span
                      class="badge"
                      [ngClass]="{
                        'bg-success': isAllocationPercentExact,
                        'bg-danger': allocationPercentExcess > 0,
                        'bg-warning text-dark': allocationPercentRemaining > 0 && allocationPercentExcess === 0
                      }">
                      Total: {{ allocationPercentTotal | number:'1.0-2' }}% / 100%
                    </span>
                  </div>

                  <div class="alert alert-danger py-2 small mb-2" *ngIf="allocationPercentExcess > 0" role="alert">
                    <i class="fas fa-exclamation-circle me-1"></i>
                    A soma passou de 100% em <strong>{{ allocationPercentExcess | number:'1.0-2' }}%</strong>.
                    O valor foi limitado automaticamente; ajuste as linhas se necessário.
                  </div>
                  <div class="alert alert-warning py-2 small mb-2" *ngIf="allocationPercentRemaining > 0" role="alert">
                    <i class="fas fa-info-circle me-1"></i>
                    Faltam <strong>{{ allocationPercentRemaining | number:'1.0-2' }}%</strong> para completar 100%.
                    <button type="button" class="btn btn-link btn-sm p-0 align-baseline ms-1" (click)="applyRemainingPercentToLastRow()">
                      Aplicar restante na última linha
                    </button>
                    <span class="text-muted mx-1">|</span>
                    <button type="button" class="btn btn-link btn-sm p-0 align-baseline" (click)="distributeEqualPercents()">
                      Dividir igualmente
                    </button>
                  </div>
                  <div class="alert alert-success py-2 small mb-2" *ngIf="isAllocationPercentExact && allRateioRowsHaveCostCenter" role="alert">
                    <i class="fas fa-check-circle me-1"></i>
                    Divisão fechada em 100%.
                  </div>

                  <div class="table-responsive">
                    <table class="table table-sm mb-0">
                      <thead>
                        <tr>
                          <th>Centro de custo</th>
                          <th style="width: 120px">%</th>
                          <th class="text-end" style="width: 130px">Valor (R$)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let row of costCenterAllocations; let i = index">
                          <td>
                            <select
                              class="form-select form-select-sm"
                              [ngModel]="row.costCenterId"
                              [ngModelOptions]="{standalone: true}"
                              (ngModelChange)="onAllocationCostCenterChange(i, $event)">
                              <option [ngValue]="null">Selecione...</option>
                              <option *ngFor="let cc of getCostCentersAvailableForRow(i)" [ngValue]="cc.id">
                                {{ cc.name }}
                              </option>
                            </select>
                          </td>
                          <td>
                            <div class="input-group input-group-sm">
                              <input
                                type="number"
                                class="form-control text-end"
                                [ngModel]="row.percent"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="onAllocationPercentChange(i, $event)"
                                min="0"
                                max="100"
                                step="0.01"
                                [attr.max]="100"
                                title="Máximo permitido nesta linha sem ultrapassar 100% no total" />
                              <span class="input-group-text">%</span>
                            </div>
                          </td>
                          <td class="text-end align-middle">
                            <span
                              class="fw-semibold"
                              [class.text-success]="isAllocationPercentExact && rateioBaseAmount > 0"
                              [class.text-muted]="!isAllocationPercentExact || rateioBaseAmount <= 0">
                              {{ getAllocationRowAmount(i) | currency:'BRL':'symbol':'1.2-2' }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot *ngIf="rateioBaseAmount > 0">
                        <tr class="table-light">
                          <th colspan="2" class="text-end">Soma da divisão no mês</th>
                          <th class="text-end">
                            <span [class.text-success]="isAllocationPercentExact" [class.text-warning]="!isAllocationPercentExact">
                              {{ rateioAllocatedMonthTotal | currency:'BRL':'symbol':'1.2-2' }}
                            </span>
                            <span class="text-muted fw-normal"> / {{ rateioBaseAmount | currency:'BRL':'symbol':'1.2-2' }}</span>
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>

                  <div class="ap-rateio-value-hint small mt-2" *ngIf="rateioBaseAmount > 0 && rateioValueRemaining > 0">
                    <i class="fas fa-coins me-1 text-warning"></i>
                    Faltam <strong>{{ rateioValueRemaining | currency:'BRL':'symbol':'1.2-2' }}</strong> na divisão para fechar o valor informado (complete 100% nos percentuais).
                  </div>
                  <div class="ap-rateio-value-hint small mt-2 text-success" *ngIf="rateioBaseAmount > 0 && isAllocationPercentExact">
                    <i class="fas fa-check me-1"></i>
                    O valor <strong>{{ rateioBaseAmount | currency:'BRL':'symbol':'1.2-2' }}</strong> está totalmente distribuído entre os centros de custo.
                    <span *ngIf="rateioMonthCount > 1">
                      Total do lote ({{ rateioMonthCount }} meses):
                      <strong>{{ rateioBaseAmount * rateioMonthCount | currency:'BRL':'symbol':'1.2-2' }}</strong>.
                    </span>
                  </div>
                </div>
              </div>

              <!-- Esboço divisão: parcelas, datas, CC e valores (como no parcelado) -->
              <div class="col-12" *ngIf="showDivisaoEsboco">
                <div class="ap-lote-section ap-parcelado-esboco">
                  <h6 class="ap-lote-section-title mb-2">
                    <i class="fas fa-list-alt me-2"></i>
                    Como ficará o parcelamento
                    <span class="badge bg-primary ms-2" *ngIf="!isDivisaoEsbocoUsingFullPreview">
                      {{ divisaoEsbocoRows.length }} título(s) — esboço
                    </span>
                    <span class="badge bg-primary ms-2" *ngIf="isDivisaoEsbocoUsingFullPreview">
                      {{ batchTitleCount }} título(s)
                    </span>
                  </h6>
                  <div class="form-check mb-2" *ngIf="showBatchDueDateOptions">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="adjustWeekendsBusinessDayDivisao"
                      [(ngModel)]="adjustWeekendsToBusinessDay"
                      [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="onAdjustWeekendsToBusinessDayChange($event)" />
                    <label class="form-check-label" for="adjustWeekendsBusinessDayDivisao">
                      Ajustar <strong>sábado e domingo</strong> para o <strong>próximo dia útil</strong> (segunda-feira)
                    </label>
                  </div>
                  <p class="text-muted small mb-2">
                    <i class="fas fa-info-circle me-1"></i>
                    Esboço em <strong>dias corridos</strong> a partir do 1º vencimento.
                    Use o <i class="fas fa-pencil-alt"></i> para alterar uma data manualmente.
                    <span *ngIf="!isDivisaoEsbocoUsingFullPreview && rateioBaseAmount < 0.01">
                      Selecione os <strong>centros de custo</strong> e os <strong>%</strong>; informe o <strong>valor do mês</strong> para ver os valores em R$.
                    </span>
                    <span *ngIf="!isDivisaoEsbocoUsingFullPreview && rateioBaseAmount >= 0.01">
                      Valores por centro conforme os <strong>%</strong> informados. Feche em <strong>100%</strong> para confirmar o lote.
                    </span>
                    <span *ngIf="isDivisaoEsbocoUsingFullPreview">
                      Clique no cabeçalho da tabela para ordenar.
                    </span>
                  </p>
                  <p class="text-danger small mb-2" *ngIf="hasWeekendDueDatesInPreview">
                    <i class="fas fa-exclamation-triangle me-1"></i>
                    Vencimento em <strong>fim de semana</strong> aparece em vermelho — ajuste com o lápis se necessário.
                  </p>
                  <div class="preview-table-wrap">
                    <table class="table table-sm table-striped mb-0">
                      <thead>
                        <tr>
                          <th class="ap-sortable-th" (click)="toggleBatchPreviewSort('line')" title="Ordenar por sequência">
                            # <i class="fas fa-xs ms-1" [ngClass]="getBatchSortIconClass('line')"></i>
                          </th>
                          <th class="ap-sortable-th" (click)="toggleBatchPreviewSort('document')" title="Ordenar por documento">
                            Documento <i class="fas fa-xs ms-1" [ngClass]="getBatchSortIconClass('document')"></i>
                          </th>
                          <th class="ap-sortable-th" (click)="toggleBatchPreviewSort('installment')" title="Ordenar por parcela">
                            Parcela <i class="fas fa-xs ms-1" [ngClass]="getBatchSortIconClass('installment')"></i>
                          </th>
                          <th class="ap-sortable-th" (click)="toggleBatchPreviewSort('dueDate')" title="Ordenar por vencimento">
                            Vencimento <i class="fas fa-xs ms-1" [ngClass]="getBatchSortIconClass('dueDate')"></i>
                          </th>
                          <th class="ap-sortable-th" (click)="toggleBatchPreviewSort('costCenter')" title="Ordenar por centro de custo">
                            Centro de custo <i class="fas fa-xs ms-1" [ngClass]="getBatchSortIconClass('costCenter')"></i>
                          </th>
                          <th
                            class="ap-sortable-th text-end"
                            *ngIf="showDivisaoEsbocoPercentColumn"
                            (click)="toggleBatchPreviewSort('percent')"
                            title="Ordenar por percentual">
                            % <i class="fas fa-xs ms-1" [ngClass]="getBatchSortIconClass('percent')"></i>
                          </th>
                          <th class="ap-sortable-th text-end" (click)="toggleBatchPreviewSort('amount')" title="Ordenar por valor">
                            Valor <i class="fas fa-xs ms-1" [ngClass]="getBatchSortIconClass('amount')"></i>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let row of sortedDivisaoEsbocoRows">
                          <td>{{ row.lineNumber }}</td>
                          <td class="ap-doc-cell" [title]="row.documentNumber">{{ row.documentNumber }}</td>
                          <td>{{ row.monthIndex }}/{{ row.monthTotal }}</td>
                          <td class="ap-preview-due-date">
                            <ng-container *ngIf="editingDueDateDocumentNumber !== row.documentNumber">
                              <span
                                [class.ap-due-date-weekend]="showWeekendDueDateWarning(row.dueDate)"
                                [class.text-primary]="isBatchDueDateOverridden(row.documentNumber) && !showWeekendDueDateWarning(row.dueDate)">
                                {{ row.dueDate | date:'dd/MM/yyyy' }}
                              </span>
                              <span
                                class="badge bg-light text-muted border ms-1"
                                *ngIf="isBatchDueDateOverridden(row.documentNumber)">ajustado</span>
                              <button
                                type="button"
                                class="btn btn-link btn-sm ap-due-date-edit-btn p-0 ms-1"
                                (click)="startEditBatchDueDate(row)"
                                title="Alterar vencimento">
                                <i class="fas fa-pencil-alt"></i>
                              </button>
                              <button
                                type="button"
                                class="btn btn-link btn-sm text-muted p-0 ms-1"
                                *ngIf="isBatchDueDateOverridden(row.documentNumber)"
                                (click)="resetBatchDueDateOverride(row)"
                                title="Voltar ao automático">
                                <i class="fas fa-undo"></i>
                              </button>
                            </ng-container>
                            <div
                              class="d-flex align-items-center gap-1"
                              *ngIf="editingDueDateDocumentNumber === row.documentNumber">
                              <input
                                type="date"
                                class="form-control form-control-sm"
                                [ngModel]="formatDueDateForInput(row.dueDate)"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="onBatchPreviewDueDateChange(row, $event)" />
                              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="cancelEditBatchDueDate()">
                                <i class="fas fa-times"></i>
                              </button>
                            </div>
                          </td>
                          <td>
                            <span *ngIf="row.costCenterId">{{ getCostCenterName(row.costCenterId) }}</span>
                            <span class="text-muted" *ngIf="!row.costCenterId">Selecione o centro de custo acima</span>
                          </td>
                          <td class="text-end" *ngIf="showDivisaoEsbocoPercentColumn">
                            {{ row.percent > 0 ? (row.percent | number:'1.0-2') + '%' : '—' }}
                          </td>
                          <td class="text-end">
                            <span *ngIf="row.amount > 0" class="fw-semibold">{{ row.amount | currency:'BRL' }}</span>
                            <span *ngIf="row.amount <= 0" class="text-muted">—</span>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot *ngIf="divisaoEsbocoRows.length > 0 && (rateioBaseAmount > 0 || divisaoEsbocoShowsCcBreakdown)">
                        <tr class="table-light">
                          <th [attr.colspan]="showDivisaoEsbocoPercentColumn ? 6 : 5" class="text-end">Total do lote</th>
                          <th class="text-end text-primary">{{ divisaoEsbocoAmountTotal | currency:'BRL':'symbol':'1.2-2' }}</th>
                        </tr>
                        <tr class="table-light">
                          <td [attr.colspan]="showDivisaoEsbocoPercentColumn ? 7 : 6" class="small border-0 pt-0">
                            <ng-container *ngIf="isDivisaoEsbocoUsingFullPreview">
                              Base mensal:
                              <strong>{{ rateioBaseAmount | currency:'BRL':'symbol':'1.2-2' }}</strong>
                              × {{ rateioMonthCount }} mês(es) × {{ costCenterCount }} centro(s) =
                              <strong>{{ divisaoEsbocoAmountTotal | currency:'BRL':'symbol':'1.2-2' }}</strong>
                            </ng-container>
                            <ng-container *ngIf="!isDivisaoEsbocoUsingFullPreview">
                              {{ rateioMonthCount }} × {{ rateioBaseAmount | currency:'BRL':'symbol':'1.2-2' }} (valor/mês) =
                              <strong>{{ divisaoEsbocoAmountTotal | currency:'BRL':'symbol':'1.2-2' }}</strong> no cronograma
                            </ng-container>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
              <p class="text-muted small mb-0" *ngIf="isRateioMode && !showDivisaoEsboco">
                Informe a <strong>data do 1º vencimento</strong> para ver o esboço da divisão por centro de custo.
              </p>
              
              <div class="col-12">
                <div class="total-preview">
                  <h5 *ngIf="isParceladoMode && batchInstallmentNetAmount > 0">
                    Valor de cada parcela:
                    <span class="text-secondary">{{ batchInstallmentNetAmount | currency:'BRL':'symbol':'1.2-2' }}</span>
                  </h5>
                  <h5 *ngIf="isParceladoMode && batchPreviewRows.length > 0">
                    Total do lote ({{ batchTitleCount }} parcela(s)):
                    <span class="text-primary">{{ batchPreviewAmountTotal | currency:'BRL':'symbol':'1.2-2' }}</span>
                  </h5>
                  <h5 *ngIf="isRateioMode && rateioBaseAmount > 0">
                    Valor do mês (divisão):
                    <span class="text-primary">{{ rateioBaseAmount | currency:'BRL':'symbol':'1.2-2' }}</span>
                  </h5>
                  <h5 *ngIf="isRateioMode && rateioMonthCount > 1 && batchPreviewRows.length > 0">
                    Total do lote ({{ rateioMonthCount }} meses × divisão):
                    <span class="text-primary">{{ batchPreviewAmountTotal | currency:'BRL':'symbol':'1.2-2' }}</span>
                  </h5>
                  <h5 *ngIf="!isBatchMode">
                    Valor Total a Pagar:
                    <span class="text-primary">{{ calculateTotalAmount() | currency:'BRL':'symbol':'1.2-2' }}</span>
                  </h5>
                  <small class="text-muted" *ngIf="isRateioMode && batchTitleCount > 0">
                    {{ rateioMonthCount }} meses × {{ costCenterCount }} centros = {{ batchTitleCount }} título(s).
                  </small>
                  <small class="text-muted" *ngIf="isParceladoMode && batchPreviewRows.length > 0">
                    Cada linha repete o valor da parcela; desconto, juros e multa aplicam em todas.
                  </small>
                </div>
              </div>
            </div>
          </div>

          <!-- Step 3: Fornecedor e Classificação -->
          <div *ngIf="currentStep === 3" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-building me-2"></i>
              Fornecedor e Classificação
            </h3>
            
            <div [formGroup]="formStep3" class="row g-3">
              <div class="col-md-6">
                <label for="supplierId" class="form-label">Fornecedor</label>
                <select 
                  id="supplierId"
                  class="form-select"
                  formControlName="supplierId">
                  <option value="">Selecione...</option>
                  <option *ngFor="let supplier of suppliers" [value]="supplier.id">
                    {{ supplier.companyName }}
                  </option>
                </select>
              </div>
              
              <div class="col-md-6">
                <label for="category" class="form-label">Categoria *</label>
                <select 
                  id="category"
                  class="form-select"
                  formControlName="category"
                  [class.is-invalid]="isFieldInvalid('category', 3)">
                  <option value="">Selecione...</option>
                  <option *ngFor="let category of categoryOptions" [value]="category">
                    {{ category }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('category', 3)">
                  {{ getFieldError('category', 3) }}
                </div>
              </div>
              
              <div class="col-md-6" *ngIf="showCostCenterOnStep3">
                <label for="costCenterId" class="form-label">Centro de Custo</label>
                <select 
                  id="costCenterId"
                  class="form-select"
                  formControlName="costCenterId">
                  <option value="">Selecione...</option>
                  <option *ngFor="let costCenter of costCenters" [value]="costCenter.id">
                    {{ costCenter.name }}
                  </option>
                </select>
              </div>
              
              <div class="col-md-6" *ngIf="isEditMode && isAccountPaidStatus">
                <label class="form-label">Status</label>
                <div class="form-control-plaintext fw-semibold">{{ accountsPayable?.status }}</div>
                <small class="text-muted">Contas pagas não alteram status por aqui.</small>
              </div>
              <div class="col-md-6" *ngIf="isEditMode && !isAccountPaidStatus">
                <label for="status" class="form-label">Status *</label>
                <select 
                  id="status"
                  class="form-select"
                  formControlName="status"
                  [class.is-invalid]="isFieldInvalid('status', 3)">
                  <option value="">Selecione...</option>
                  <option *ngFor="let status of editStatusOptions" [value]="status.name">
                    {{ status.name }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('status', 3)">
                  {{ getFieldError('status', 3) }}
                </div>
              </div>
              <div class="col-md-6" *ngIf="!isEditMode">
                <label class="form-label">Status</label>
                <div class="form-control-plaintext fw-semibold text-secondary">
                  Pendente
                </div>
                <small class="text-muted">O pagamento é registrado depois, na visualização da conta.</small>
              </div>
            </div>
          </div>

          <!-- Navegação dos Steps -->
          <div class="step-navigation">
            <button 
              type="button" 
              class="btn btn-outline-secondary"
              (click)="previousStep()"
              [disabled]="currentStep === 1">
              <i class="fas fa-arrow-left me-2"></i>
              Anterior
            </button>
            
            <div class="step-info">
              Passo {{ currentStep }} de {{ totalSteps }}
            </div>
            
            <button 
              type="button" 
              class="btn btn-primary"
              (click)="nextStep()"
              [disabled]="!canProceedToNextStep()"
              *ngIf="currentStep < totalSteps">
              Próximo
              <i class="fas fa-arrow-right ms-2"></i>
            </button>
            
            <button 
              type="button" 
              class="btn btn-primary"
              (click)="submitForm()"
              [disabled]="!isFormValid() || isSubmitting"
              *ngIf="currentStep === totalSteps">
              <i class="fas fa-save me-2"></i>
              {{ isEditMode ? 'Atualizar' : 'Salvar' }}
              <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm ms-2" role="status"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
